import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { PocModel } from '../model/index';

@Injectable()
export class PocService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private pocUrl = 'api/poc';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPocList(query: any): Promise<PocModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.pocUrl}/pocList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPoc(id: number): Promise<PocModel> {
        const url = `${this.pocUrl}/pocList?id=${id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as PocModel)
            .catch(this.handleError);
    }

    deletePoc(id: any): Promise<PocModel> {
        const url = `${this.pocUrl}/deletePoc`;
        return this.http
            .post(url, $.param({ id: id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PocModel)
            .catch(this.handleError);
    }

    addUpdatePoc(pocData: any): Promise<PocModel> {

        const url = `${this.pocUrl}/addUpdatePoc`;

        return this.http
            .post(url, $.param(pocData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PocModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/poc.service.ts